import React, { useEffect } from 'react';

export default function ClearCache(props) {
    useEffect(() => {
        localStorage.clear();
    }, []);  

    return(
        <div>Done</div>
    );

}
